import React, { useState } from 'react';
import { Service } from '@yleisradio/areena-types';

type Value = {
  service: Service;
  setService: (service: Service) => void;
};

const ServiceContext = React.createContext<Value>({
  service: 'tv',
  setService: () => {
    throw new Error('Service context not initialized');
  },
});

export const ServiceContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [service, setService] = useState<Service>('tv');

  return (
    <ServiceContext.Provider value={{ service, setService }}>
      {children}
    </ServiceContext.Provider>
  );
};

export const useServiceContext = () => {
  return React.useContext(ServiceContext);
};

export default ServiceContext;
